module.exports = __webpack_public_path__ + "img/manet_2.a2ba9262.jpg";